import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useStateContext } from "../../contexts/ContextProvider";
import { signInWithGoogle } from "../../firebase";
import Logo from "../../data/bookwie-logo.png";

export default function Login() {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useStateContext();

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError("");

    try {
      // Sign in with Google via Firebase
      const idToken = await signInWithGoogle();

      // Send Firebase ID token to backend for verification
      const apiUrl = process.env.REACT_APP_API_URL || "https://api.bookwie.com";
      const response = await axios.post(`${apiUrl}/api/auth/google-login`, {
        idToken,
      });

      if (response.data.success) {
        login(response.data.data.token);
        navigate("/dashboard");
      } else {
        setError(response.data.message || "Login failed, please try again.");
      }
    } catch (err) {
      if (err.code === "auth/popup-closed-by-user") {
        setError("");
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-main-bg px-4 overflow-hidden">
      <div className="absolute -top-40 -right-40 w-[480px] h-[480px] rounded-full bg-brand-200/60 blur-3xl" />
      <div className="absolute -bottom-40 -left-40 w-[420px] h-[420px] rounded-full bg-brand-100 blur-3xl" />

      <div className="relative w-full max-w-sm card p-8">
        <img src={Logo} alt="Bookwie" className="h-8 w-auto mx-auto" />
        <h1 className="text-center text-xl font-semibold text-gray-900 mt-8">Admin sign in</h1>
        <p className="text-center text-sm text-gray-500 mt-1.5">Use your authorised Google account.</p>

        {error && (
          <div role="alert" className="mt-6 rounded-2xl bg-red-50 text-red-700 text-sm px-4 py-3 text-center">{error}</div>
        )}

        <button
          onClick={handleGoogleLogin}
          disabled={loading}
          className="mt-6 w-full flex items-center justify-center gap-3 py-3 px-4 rounded-full border border-gray-200 bg-white text-sm font-medium text-gray-900 hover:border-brand-300 hover:bg-brand-50 transition disabled:opacity-50"
        >
          <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
            <path
              fill="#EA4335"
              d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
            />
            <path
              fill="#4285F4"
              d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
            />
            <path
              fill="#FBBC05"
              d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
            />
            <path
              fill="#34A853"
              d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
            />
          </svg>
          {loading ? "Signing in…" : "Continue with Google"}
        </button>
      </div>
    </div>
  );
}
